import api from './axios';

/**
 * The Admin Operations Dashboard. ONE call rather than six, so every panel on
 * the screen describes the same moment — six parallel requests would show a
 * KPI that disagrees with the list underneath it.
 *
 * A Branch Admin's figures are scoped server-side (Rule 65), so this returns
 * their branch's numbers rather than a filtered global set.
 */
export const getOperationsDashboard = () => api.get('/v1/dashboard/summary');
